
import React from 'react';
import { TextField } from 'office-ui-fabric-react/lib/TextField';

const AttributeTextField = ({definition, values}) => {
    return (
        <TextField
            key={definition.name}
            label={definition.title}
            value={values[definition.name]}
            readOnly={true}
        />
    );
}

export default AttributeTextField;
